export default __webpack_public_path__ + "media/zurb/img/experience-design/journey_mapping-ff839ec09f58db7269da91fea0b2f39f.png";